import React from 'react'
import PropTypes from 'prop-types'

// Head of an inline config panel: badge, title, subtitle; Cancel sits in the footer (RTM-10086).

const ConfigPanelHead = ({ badge, title, subtitle }) => (
  <div className="gl-event-setup-sc-head">
    <div className="gl-event-setup-sc-head-left">
      <div className="gl-event-setup-sc-badge" aria-hidden="true">{badge}</div>
      <div>
        <div className="gl-event-setup-sc-title">{title}</div>
        {subtitle && <div className="gl-event-setup-sc-sub">{subtitle}</div>}
      </div>
    </div>
  </div>
)

ConfigPanelHead.propTypes = {
  badge: PropTypes.node,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
}

export default ConfigPanelHead
